var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/arrow-down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/arrow-down",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2426407,13.6568542 L8.29289322,8.70710678 C7.90236893,8.31658249 7.90236893,7.68341751 8.29289322,7.29289322 C8.68341751,6.90236893 9.31658249,6.90236893 9.70710678,7.29289322 L15.363961,12.9497475 C15.7544853,13.3402718 15.7544853,13.9734367 15.363961,14.363961 L9.70710678,20.0208153 C9.31658249,20.4113396 8.68341751,20.4113396 8.29289322,20.0208153 C7.90236893,19.630291 7.90236893,18.997126 8.29289322,18.6066017 L13.2426407,13.6568542 Z",
    id: "Path",
    fill: "#4C4C4C",
    fillRule: "nonzero",
    transform: "translate(11.828427, 13.656854) rotate(-270.000000) translate(-11.828427, -13.656854) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownArrow);
export default __webpack_public_path__ + "static/media/icon_down_arrow.68e5c6937b9c0c620bd453a3c1969ca9.svg";
export { ForwardRef as ReactComponent };